import { usePlan, usePlanUserProgress, useUser } from './use-plan-data'

export function useActivePlan() {
  const { data: userData } = useUser()

  const me = userData?.me
  const activePlanId = me?.activePlanId ?? me?.availablePlans[0]?.id
  const activePlan =
    me?.availablePlans.find((p) => p.id === activePlanId) ??
    me?.availablePlans[0]

  // Derive current week number from BE's `userProgress.currentSegmentId`.
  // `currentSegmentId` lives in its own minimal query (PlanUserProgress) —
  // see `usePlanUserProgress` for why it can't be combined with segments.
  const { data: planData } = usePlan(activePlanId)
  const { data: progressData } = usePlanUserProgress(activePlanId)
  const currentSegmentId = progressData?.myPlan?.userProgress?.currentSegmentId
  const currentWeekNumber =
    planData?.myPlan?.segments.find((s) => s.id === currentSegmentId)?.number ??
    1

  return {
    me,
    activePlan,
    activePlanId,
    currentWeekNumber,
  }
}
